// extracted by mini-css-extract-plugin
module.exports = {"modal":"r_1","modal__bg":"r_2","modal__close":"r_3","modal__header":"r_4","modal__header__close":"r_5","modal__content":"r_6"};